import "../../jquery-global.js";
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;


$('input[type="range"]').each(function(event){
  var sheet = document.createElement('style'),  
    $rangeInput = $(this);
    var num = event;
    $rangeInput.parent('.range').attr('id', 'range-'+num);    

  var $rangeLabels = $(this).parent('.range').prev('ul.range-labels');

  var getTrackStyle = function (el) {  
    var curVal = el.value,
        val = (curVal - 1) * 24,
        style = '';
    
    // Set active label    
    $rangeLabels.find('li').removeClass('active selected');
    
    var curLabel = $rangeLabels.find('li:nth-child(' + curVal + ')');
    
    curLabel.addClass('active selected');
    curLabel.prevAll().addClass('selected');
    
  }

  $rangeInput.on('input', function () {
    sheet.textContent = getTrackStyle(this);
  });

  // Change input value on label click
  $rangeLabels.find('li').on('click', function () {
    var index = $(this).index();
    
    $rangeInput.val(index + 1).trigger('input');
    
  });
});


